import React, { useContext, useEffect, useState } from 'react';
import Slider from "@mui/material/Slider";
import Timeline from "../TimeLine.module.css";
import { Context } from "../../Map/Context";
import { disableMapDragging, enableMapDragging } from "../../Map/MapEvents/MapEvents";
import axios from "axios";
import { URL_FOR_MARKS } from "../../../config/config";

export function ClocksForDate(props) {
    const [context, setContext] = useContext(Context);
    const [timeSlider, setTimeSlider] = useState([]);

    const currentSatelliteGlobal = {
        suomi: '&satellite=npp',
        noaa: '&satellite=jp1',
        empty: ''
    };

    const satelliteNames = {
        'jp1': 'NOAA-20',
        'jp2': 'NOAA-21',
        'npp': 'Suomi NPP',
        'f3d': 'FengYun-3D',
        'f3e': 'FengYun-3E',
        'f3f': 'FengYun-3F'
    };

    const requestForTime = (contextCurrentDate, suomi, noaa) => {
        const currentSatellite = suomi ? currentSatelliteGlobal.suomi : noaa ? currentSatelliteGlobal.noaa : currentSatelliteGlobal.empty;
        return axios.get(`${URL_FOR_MARKS.URL_GET_TIME_FROM_DATE}?date=${contextCurrentDate}${currentSatellite}`)
            .then(response => response.data.time[context.currentDate] || [])
            .catch(error => {
                console.log(error.message);
                return [];
            });
    };

    const timeValue = (e, val) => {
        const currentItem = timeSlider.find(element => element.value === val);
        if (!currentItem || !currentItem.timeStr) return;

        const currentTime = currentItem.timeStr + ':00';

        const datetime_as_date = Date.parse(`${context.currentDate}T${currentTime}`);
        setContext({
            ...context,
            singleDay: true,
            min_datetime: datetime_as_date,
            max_datetime: datetime_as_date
        });
    };

    const resetTime = () => {
        if (context.singleDay) {
            const min_datetime_as_date = Date.parse(`${context.currentDate}T00:00:00`);
            const max_datetime_as_date = Date.parse(`${context.currentDate}T23:59:59`);
            setContext({
                ...context,
                min_datetime: min_datetime_as_date,
                max_datetime: max_datetime_as_date
            });
        }
    };

    useEffect(() => {
        if (context.singleDay || context.today) {
            requestForTime(context.currentDate, props.satelliteSuomi, props.satelliteNoaa)
                .then(response => {
                    const sorted = response.sort((a,b) => a.time.localeCompare(b.time));
                    const formatted = sorted.map((item, i) => {
                        const satName = satelliteNames[item.satellite];
                        return { 
                            value: i * 9, 
                            label: satName ? (
                                <span title={satName} style={{ pointerEvents: 'auto', display: 'inline-block', padding: '5px' }}>
                                    {item.time}
                                </span>
                            ) : (
                                <span style={{ pointerEvents: 'auto', display: 'inline-block', padding: '5px' }}>{item.time}</span>
                            ),
                            timeStr: item.time
                        };
                    });
                    setTimeSlider(formatted);
                })
                .catch(() => setTimeSlider([]));
        }
    }, [context, props.satelliteSuomi, props.satelliteNoaa]);

    return (
        <>
            <div 
                className={Timeline.divSlider}
                onMouseDown={() => disableMapDragging(props.map)}
                onMouseUp={() => enableMapDragging(props.map)}
            >
                <Slider
                    color={'primary'}
                    sx={{
                        width: 800,
                        left: 30,
                        bottom: 1,
                        '& .MuiSlider-mark': { height: 10 },
                        '& .MuiSlider-markLabel': { pointerEvents: 'auto' }
                    }}
                    defaultValue={9}
                    track={false}
                    onChange={timeValue}
                    step={9}
                    marks={timeSlider}
                    max={175}
                />
            </div>
            
            <button className={Timeline.resetBtn} onClick={resetTime}>
                Сбросить время
            </button>
        </>
    );
}
